// import Input from "@/components/ui/input";
// import { useRouter } from "@/i18n/navigation";
// import { Text } from "rsuite";
// import styles from "./styles.module.scss";

// export default function PlacingOrder({ userData }: any) {
//   const path = useRouter();

//   return (
//     <div className={styles.orderRoot}>
//       <Text className={styles.orderTitle}>Оформление заказа</Text>
//       <div className={styles.orderWrapper}>
//         <div className={styles.inputItem}>
//           <Input
//             label="Мобильный телефон"
//             state={userData?.phone}
//             type="text"
//           />
//         </div>
//         <div className={styles.inputItem}>
//           <Input label="Ваше имя" state={userData?.firstName} type="text" />
//         </div>

//         <div className={styles.inputItem}>
//           <Input label="E-mail" state={userData?.email} type="email" />
//         </div>
//       </div>
//       <div className={styles.orderFooter}>
//         <div className={styles.event}>
//           <button
//             onClick={() => path.push("/order")}
//             type="button"
//             className={styles.button1}
//           >
//             Оформить
//           </button>
//           <button type="button" className={styles.button2}>
//             Оформить в рассрочку
//           </button>
//         </div>
//         <div className={styles.alertWrapper}>
//           <Text className={styles.alertText}>
//             Нажимая на кнопку &quot;Оформить&quot;, Вы соглашаетесь с условиями{" "}
//             <span style={{ color: "#2563EB" }}>Публичной оферты</span> и
//             подтверждаете своё{" "}
//             <span style={{ color: "#2563EB" }}>
//               Согласие на обработку персональных данных.
//             </span>
//           </Text>
//         </div>
//       </div>
//     </div>
//   );
// }

'use client';
import { SEND_OTP_MUTATION } from '@/apollo/graphql/mutations/authMutations/otpMutations';
import { PasswordContent } from '@/components';
import Input from '@/components/ui/input';
import { useAuthStore } from '@/zustand/useAuth';
import useIsBuying from '@/zustand/useIsBuying';
import { useMutation } from '@apollo/client';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';
import { useState } from 'react';
import { Modal, Text } from 'rsuite';
import styles from './styles.module.scss';
import { UserDraftOrdersQuery } from '@/graphql';

interface PlacingOrderProps {
  userData?: any | null;
  modalOpen?: () => void;
  orderData?: UserDraftOrdersQuery | null;
}

export default function PlacingOrder({
  userData,
  modalOpen,
  orderData,
}: PlacingOrderProps) {
  const [form, setForm] = useState({
    phone: userData?.phone || '+998',
    firstName: userData?.firstName || '',
    email: userData?.email || '',
  });
  const [sendOtp, { loading }] = useMutation(SEND_OTP_MUTATION);
  const setPhone = useAuthStore(state => state.setPhone);
  const setIsBuying = useIsBuying(state => state.setIsBuying);
  const isLoggedIn = Boolean(userData?.id);
  const [errors, setErrors] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const router = useRouter();

  const handleChange = (field: string, value: string) => {
    if (field === 'phone') {
      // Always keep +998 at the start
      if (!value.startsWith('+998')) {
        value = '+998';
      }

      // Only allow digits after +998
      const digitsOnly = value.replace(/\D/g, '').slice(3, 12); // slice 7 digits
      value = '+998' + digitsOnly;
    }

    setForm(prev => ({ ...prev, [field]: value }));
    setErrors((prev: any) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const newErrors: any = {};
    const phoneRegex = /^\+998\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-zА-Яа-яЁё\s]{1,35}$/;

    if (!form.phone || !phoneRegex.test(form.phone)) {
      console.log('4');

      newErrors.phone = {
        message: 'Введите номер мобильного телефона!',
      };
    }

    if (form.firstName && !nameRegex.test(form.firstName)) {
      newErrors.firstName = {
        message: 'Имя может содержать только буквы (макс. 35 символов)',
      };
    }

    if (form.email && !emailRegex.test(form.email)) {
      newErrors.email = {
        message: 'Введите корректный Email',
      };
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    if (isLoggedIn) {
      router.push('/order');
      return;
    }

    try {
      const response = await sendOtp({ variables: { phone: form.phone } });

      if (response.data?.sendOtp?.status) {
        setPhone(form.phone);
        setIsBuying(true);
        setOpenModal(true);
      } else {
        console.error('Ошибка отправки OTP:', response.data?.sendOtp?.errors);
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  };

  const handleClose = () => setOpenModal(false);
  const t = useTranslations('Components.placing-order');

  const handleFormalizeCreditClick = () => {
    if (modalOpen) {
      modalOpen();
    } else {
      router.push('/order');
    }
  };

  return (
    <div className={styles.orderRoot}>
      <Text className={styles.orderTitle}>{t('order-processing')}</Text>
      <div className={styles.orderWrapper}>
        <div className={styles.inputItem}>
          <Input
            name="phone"
            label={t('mobile-number')}
            state={form.phone}
            setState={val => handleChange('phone', val)}
            error={errors}
            type="text"
          />
        </div>
        <div className={styles.inputItem}>
          <Input
            name="firstName"
            label={t('your-name')}
            state={form.firstName}
            setState={val => handleChange('firstName', val)}
            error={errors}
            type="text"
            maxLength={35}
          />
        </div>
        <div className={styles.inputItem}>
          <Input
            name="email"
            label={t('email')}
            state={form.email}
            setState={val => handleChange('email', val)}
            error={errors}
            type="email"
          />
        </div>
      </div>
      <div className={styles.orderFooter}>
        <div className={styles.event}>
          <button
            onClick={handleSubmit}
            type="button"
            className={styles.button1}
          >
            {t('formalize')}
          </button>
          {orderData ? (
            <button
              onClick={handleFormalizeCreditClick}
              type="button"
              className={styles.button2}
              disabled={
                orderData.userDraftOrders?.[0]?.installmentsWithoutIntegration
                  ?.length === 0
              }
            >
              {t('formalize-credit')}
            </button>
          ) : (
            <button
              onClick={handleFormalizeCreditClick}
              type="button"
              className={styles.button2}
            >
              {t('formalize-credit')}
            </button>
          )}
        </div>
        <div className={styles.alertWrapper}>
          <Text className={styles.alertText}>
            {t('privacy-policy')}{' '}
            <a
              style={{ color: '#2563EB' }}
              href="https://drive.google.com/file/d/1kECqNJWZ5RqGF_mEGdcqa4qVSjzO_LEJ/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('public-offer')}
            </a>{' '}
            {t('and')} {t('self-confirm')}{' '}
            <span style={{ color: '#2563EB' }}>
              {t('confirm-personal-data')}
            </span>
          </Text>
        </div>
      </div>

      <Modal
        // size="xs"
        open={openModal}
        onClose={handleClose}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div className={styles.cabinetWrapper}>
          <PasswordContent onClose={handleClose} />
        </div>
      </Modal>
    </div>
  );
}
